import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f77ba258")

_pushScopeId("data-v-f77ba258")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", null, "Cartões", -1)
const _hoisted_4 = { class: "card-container" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Adicionar cartão")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HeaderWallet = _resolveComponent("HeaderWallet")
  const _component_credit_card_card = _resolveComponent("credit-card-card")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_footer = _resolveComponent("ion-footer")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_HeaderWallet, {
            title: "Seu saldo",
            "cash-back-value": $setup.user.cashbackValue
          }, null, 8, ["cash-back-value"]),
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode("div", _hoisted_4, [
                ($setup.cards.cards.length == 0)
                  ? (_openBlock(), _createBlock("span", _hoisted_5, "Você não possui cartões cadastrados"))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.cards.cards, (card, index) => {
                  return (_openBlock(), _createBlock(_component_credit_card_card, {
                    key: card.nickname,
                    card: card,
                    "has-delete": true,
                    onDeleteCard: ($event: any) => ($options.removeCard(index))
                  }, null, 8, ["card", "onDeleteCard"]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_button, {
                shape: "round",
                color: "primary",
                expand: "full",
                onClick: $options.openModalAddCard
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})